module.exports = __webpack_public_path__ + "static/media/MP.87e1b09e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MP.svg
// module id = 2212
// module chunks = 7